import { ParticipantView } from './ParticipantView';
import { DateTime } from 'luxon';

export interface GroupView {
  pledge: number | undefined;
  participants: ParticipantView[];
  cohortUserId: number;
  id: number;
  name: string;
  shortDescription: string;
  userCount: number;
  startDate: DateTime | string;
  endDate: string | null;
  finalizedAt: string | null;
  finalizedByUserName: string | null;
  groupLogo: string;
  pledgeReceived: boolean;
  channel: string;
  inPersonCelebration: boolean;
  currentWeekNumberIndexZero: number;
  finalized: boolean;
  createdAt: string | null;
  createdBy: string | null;
}

const empty: GroupView = {
  pledge: undefined,
  participants: [] as ParticipantView[],
  cohortUserId: 0,
  id: 0,
  name: '',
  shortDescription: '',
  userCount: 12,
  startDate: DateTime.now().plus({ month: 1 }),
  endDate: null,
  finalizedAt: null,
  finalizedByUserName: null,
  groupLogo: '',
  pledgeReceived: false,
  channel: '',
  inPersonCelebration: false,
  currentWeekNumberIndexZero: 0,
  finalized: false,
  createdAt: null,
  createdBy: null,
};

const defaultExport = { Empty: empty };
export default defaultExport;
